import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function ChiSiamo() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/page/chi-siamo").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="h-screen flex items-center justify-center text-[#6B7280]">Caricamento…</div>;
  let valori = [];
  try { valori = JSON.parse(d.values_json || "[]"); } catch { valori = []; }

  return (
    <div data-testid="page-chi-siamo">
      <section className="pt-24 md:pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#007A3D]">{d.hero_overline}</span>
          <h1 className="mt-5 font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.02] text-[#1A1A1A] max-w-4xl">{d.hero_title}</h1>
        </div>
      </section>
      <section className="pb-20 md:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7 space-y-6 text-lg text-[#374151] leading-relaxed">
            {d.intro_p1 && <p>{d.intro_p1}</p>}
            {d.intro_p2 && <p>{d.intro_p2}</p>}
            {d.intro_p3 && <p>{d.intro_p3}</p>}
          </div>
          <div className="md:col-span-5">
            <div className="rounded-3xl overflow-hidden aspect-[4/5]">
              <img src={d.intro_image} alt="Territorio" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>
      <section className="py-20 md:py-28 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#007A3D]">Mission</span>
            <h2 className="mt-4 font-display font-black tracking-tighter text-3xl md:text-4xl text-[#1A1A1A]">{d.mission_title}</h2>
            <p className="mt-6 text-[#374151] leading-relaxed">{d.mission_body}</p>
          </div>
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#007A3D]">Vision</span>
            <h2 className="mt-4 font-display font-black tracking-tighter text-3xl md:text-4xl text-[#1A1A1A]">{d.vision_title}</h2>
            <p className="mt-6 text-[#374151] leading-relaxed">{d.vision_body}</p>
          </div>
        </div>
      </section>
      {valori.length > 0 && (
        <section className="py-20 md:py-28">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#007A3D]">I nostri valori</span>
            <h2 className="mt-4 font-display font-black tracking-tighter text-3xl md:text-5xl text-[#1A1A1A] max-w-3xl">Quattro principi che guidano ogni progetto Betelgez.</h2>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {valori.map((v, i) => (
                <div key={i} className="bg-white rounded-3xl p-7 border border-[#E5E7EB] hover-lift">
                  <h3 className="font-display font-bold text-xl tracking-tight text-[#1A1A1A]">{v.t}</h3>
                  <p className="mt-3 text-sm text-[#6B7280] leading-relaxed">{v.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      <section className="py-20 md:py-28 bg-[#EAF8F0]">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="font-display font-black tracking-tighter text-3xl md:text-5xl text-[#1A1A1A]">{d.cta_title}</h2>
          <p className="mt-5 text-lg text-[#374151]">{d.cta_subtitle}</p>
          <Link to="/contatti" data-testid="cs-cta" className="mt-8 inline-flex items-center gap-2 bg-[#00A651] hover:bg-[#007A3D] text-white rounded-full px-7 py-4 font-medium">
            Contattaci <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
